'use strict';

/**
 *  Load modules
 */
import './modules/burgerMenu';
import Choices from 'choices.js';

document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll('.menu-item-has-children > a');

    links.forEach(link => {
        link.addEventListener('click', function (e) {
            const li = this.parentElement;

            if (window.innerWidth < 768) {
                if (!li.classList.contains('submenu-open')) {
                    e.preventDefault();

                    document.querySelectorAll('.menu-item-has-children.submenu-open').forEach(item => {
                        if (item !== li) item.classList.remove('submenu-open');
                    });

                    li.classList.add('submenu-open');
                }
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (window.innerWidth < 768) {
            const isClickInsideMenu = e.target.closest('.menu-item-has-children');
            if (!isClickInsideMenu) {
                document.querySelectorAll('.menu-item-has-children.submenu-open').forEach(item => {
                    item.classList.remove('submenu-open');
                });
            }
        }
    });

    function initChoices (scope = document) {
        const selects = scope.querySelectorAll('.gform_wrapper select');

        selects.forEach((selectEl) => {
            if (selectEl.classList.contains('no-choices')) return;

            if (selectEl._choicesInstance && typeof selectEl._choicesInstance.destroy === 'function') {
                selectEl._choicesInstance.destroy();
                selectEl._choicesInstance = null;
            }

            const instance = new Choices(selectEl, {
                searchEnabled: false,
                removeItemButton: false,
                shouldSort: false,
            });

            selectEl._choicesInstance = instance;
        });
    }

    initChoices(document);

    document.addEventListener('gform/post_render', (e) => {
        const formId = e.detail && e.detail.formId;
        const form = formId ? document.getElementById(`gform_${formId}`) : document;
        initChoices(form || document);
    });

    if (window.jQuery) {
        window.jQuery(document).on('gform_post_render', function (_e, formId) {
            const form = document.getElementById(`gform_${formId}`) || document;
            initChoices(form);
        });
    }
});